export enum Layouts {
  Login = 'login-layout',
  Signup = 'signup-layout',
  MobileEmulator = 'mobile-emulator-layout',
  Default = 'default-layout',
}
